import { useState } from 'react';
import { PhoneOutgoing } from 'lucide-react';
import { useParams } from 'react-router';
import useScenario from '@/hooks/useScenario';
import axiosClient from '@/utils/axiosClient';
import Loading from '../Loading';
import WebAgent from '../Scenarios/WebAgent';
import { Button } from '../ui/button';
import CallInstructions from './CallInstructions';

const TrainerInitializer = () => {
  const { scenarioId } = useParams();
  const scenario = useScenario(scenarioId);

  const [loading, setLoading] = useState<boolean>(false);
  const [token, setToken] = useState('');
  const [callId, setCallId] = useState('');
  const [internalAgentId, setInternalAgentId] = useState('');

  const startCall = async () => {
    setLoading(true);
    try {
      const authResponse = await axiosClient.post(`/v1/scenarios/${scenarioId}/start`);

      if (authResponse) {
        const { token, internal_agent_id, id } = authResponse.data;

        if (token) {
          setCallId(id);
          setToken(token);
          setInternalAgentId(internal_agent_id);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error('Failed to start call:', error);
      setLoading(false);
    }
  };

  return (
    <div>
      {scenario.isLoading || !scenario.data ? (
        <Loading />
      ) : (
        <>
          <div className="w-full max-w-4xl mx-auto">
            <CallInstructions scenario={scenario.data} />
            {loading && <Loading />}
            {!token && scenario.data.enabled && (
              <>
                <div className="mt-8">
                  <Button onClick={() => startCall()} className="w-full">
                    <PhoneOutgoing />
                    Start Scenario
                  </Button>
                </div>
              </>
            )}
            {token && (
              <>
                <div className="mt-8">
                  <WebAgent
                    key={callId + '-' + token + '-' + internalAgentId}
                    callId={callId}
                    internalAgentId={internalAgentId}
                    token={token}
                  />
                </div>
              </>
            )}

            {!scenario.data.enabled && (
              <div className="mt-8">
                <p className="text-red-500">This scenario is not ready. Please check back soon.</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default TrainerInitializer;
